
export const promos = [

  /*{
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"Essentiels du matin",
    product1:'MACHINE A CAFE DIGITALE - TELEFUNKEN',
    product2:'GRILLE PAIN 1050W INSPIRE WHITE RH - TELEFUNKEN',
    prixPromo: 289,
    prix:270,
    img1:'electromenager/cafe et petit dejeuner/cafe et petit dejeuner MACHINE A CAFE DIGITALE',
    img2:'electromenager/cafe et petit dejeuner/cafe et petit dejeuner Grille pain digital',
  },
  */
  {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"1",
    product1:'montre femme MK5057 - MICHAEL KORS',
    prixPromo: 949,
    prix:590,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20MK5057.jpeg?alt=media',
  },
    {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"2",
    product1:'montre femme MK5896 - MICHAEL KORS',
    prixPromo: 749,
    prix:590,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20MK5896.jpeg?alt=media',
  },
    {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"3",
    product1:'montre femme MK5799 - MICHAEL KORS',
    prixPromo: 770,
    prix:590,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20MK5799.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"4",
    product1:'montre homme A212J008Y - Q&Q',
    product2:'montre femme A212J005Y - Q&Q',
    prixPromo: 170,
    prix:140,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Fhomme%2Fhomme%20montre%20homme%20A212J008Y.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20A212J005Y.jpeg?alt=media',
  },
  {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"5",
    product1:'DECA MINI HACHOIR 0.35L 100W KEMG007B - DECAKILA',
    product2:'DECA HACHOIR 2L 300W KEMG011B - DECAKILA',
    prixPromo: 158,
    prix:143,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20DECA%20MINI%20HACHOIR%200.35L%20100W%20KEMG007B.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20DECA%20HACHOIR%202L%20300W%20KEMG011B.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"6",
    product1:'BATTEUR ACTIVA - UFESA',
    product2:'PRESSE AGRUME ACTIVA 40W - UFESA',
    product3:'Bouilloire Powell 1.7L - UFESA',
    prixPromo: 336,
    prix:328,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20BATTEUR%20ACTIVA.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fcafe%20et%20petit%20dejeuner%2Fcafe%20et%20petit%20dejeuner%20PRESSE%20AGRUME%20ACTIVA%2040W.jpeg?alt=media',
    img3:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20Bouilloire%20Powell%201.7L.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"7",
    product1:'Machine a cafe digitale - TELEFUNKEN',
    product2:'Grille pain digital - TELEFUNKEN',
    prixPromo: 331,
    prix:323,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fcafe%20et%20petit%20dejeuner%2Fcafe%20et%20petit%20dejeuner%20Machine%20a%20cafe%20digitale.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20Grille%20pain%20digital.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"8",
    product1:'montre femme A212J010Y - Q&Q',
    product2:'montre homme A212J009Y - Q&Q',
    product3:'montre femme A212J011Y - Q&Q',
    prixPromo: 255,
    prix:210,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20A212J010Y.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Fhomme%2Fhomme%20montre%20homme%20A212J009Y.jpeg?alt=media',
    img3:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Faccessoires%2Ffemme%2Ffemme%20montre%20femme%20A212J011Y.jpeg?alt=media',
  },
  {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"9",
    product1:'MIXEUR SKY 1200W NOIR - UFESA',
    prixPromo: 129,
    prix:109,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20MIXEUR%20SKY%201200W%20NOIR.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"10",
    product1:'DECA BOUILLOIRE 1.5L 2200W KEKT004w - DECAKILA',
    prixPromo: 98,
    prix:82,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fcafe%20et%20petit%20dejeuner%2Fcafe%20et%20petit%20dejeuner%20DECA%20BOUILLOIRE%201.5L%202200W%20KEKT004w.jpeg?alt=media',
  },
     {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"11",
    product1:'DECA FER A REPASSER 2400W KEEN001W - DECAKILA',
    prixPromo: 126,
    prix:117,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fmaison%2Fmaison%20DECA%20FER%20A%20REPASSER%202400W%20KEEN001W.jpeg?alt=media',
  },
   {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"12",
    product1:'DECA BLENDER 2EN1 1200W - DECAKILA',
    product2:'DECA HACHOIR 2L 300W - DECAKILA',
    prixPromo: 203,
    prix:188,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20DECA%20BLENDER%202EN1%201200W%20KEJB039M-1.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fcuisine%2Fpreparation%20culinaire%2Fpreparation%20culinaire%20DECA%20HACHOIR%202L%20300W%20KEMG011B.jpeg?alt=media',
  },
    {
    famille: "promos",
    categorie: "promo",
    article: "promo",
    articleName:"13",
    product1:'DECA FER A REPASSER 2400W - DECAKILA',
    product2:'DECA BALANCE 180KG - DECAKILA',
    prixPromo: 165,
    prix:152,
    img1:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/%C3%A9lectrom%C3%A9nager%20&%20cuisine%2Fmaison%2Fmaison%20DECA%20FER%20A%20REPASSER%202400W%20KEEN022R.jpeg?alt=media',
    img2:'https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/informatique%20&%20lifestyle%2Flifestyle%2Fbeaute%20&%20sante%2Fbien%20%C3%AAtre%2Fbien%20%C3%AAtre%20DECA%20BALANCE%20180KG%20KMTT038W.jpeg?alt=media',
  },
  ]
